import React, { useState } from 'react';
import { updateQuery } from '../api';
import CategorySelect from './CategorySelect';
import ModuleBadge from './ModuleBadge';
import PremiumBadge from './PremiumBadge';
import PremiumToggle from './PremiumToggle';
import DarkInput from './DarkInput';
import FormLabel from './FormLabel';
import ErrorBanner from './ErrorBanner';
import GradientButton from './GradientButton';
import GhostButton from './GhostButton';
import ActionBtn from './ActionBtn';

export default function QueryInfoCard({ query, onUpdated }) {
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState({
    category:    query.category,
    subcategory: query.subcategory || '',
    query_name:  query.query_name,
    is_premium:  query.is_premium,
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  function set(patch) { setForm(f => ({ ...f, ...patch })); }

  async function handleSave(e) {
    e.preventDefault();
    if (!form.query_name.trim()) { setError('Query name is required.'); return; }
    if (!form.category.trim())   { setError('Category is required.');   return; }
    setSaving(true); setError('');
    try {
      const updated = await updateQuery(query.id, form);
      onUpdated(updated);
      setEditing(false);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  if (!editing) {
    return (
      <div className="flex items-start justify-between">
        <div className="space-y-3">
          <div className="flex items-center gap-3 flex-wrap">
            <h1 className="text-xl font-bold font-mono" style={{ color: '#e4e6f0' }}>{query.query_name}</h1>
            {query.is_premium && <PremiumBadge />}
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <ModuleBadge module={query.category} />
            {query.subcategory && (
              <span className="text-xs font-mono" style={{ color: '#4b5563' }}>{query.subcategory}</span>
            )}
          </div>
        </div>
        <ActionBtn
          variant="indigo"
          onClick={() => { setEditing(true); setError(''); }}
          style={{ border: '1px solid #1e2130', padding: '8px 12px', fontSize: '14px' }}
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6.5-6.5a2 2 0 012.828 2.828L11 16H8v-3z" />
          </svg>
          Edit
        </ActionBtn>
      </div>
    );
  }

  return (
    <form onSubmit={handleSave} className="space-y-4">

      <CategorySelect
        category={form.category} subcategory={form.subcategory}
        onChange={set}
      />

      <div>
        <FormLabel>Query Name</FormLabel>
        <DarkInput
          type="text" value={form.query_name}
          onChange={e => set({ query_name: e.target.value })}
          style={{ fontFamily: "'Courier New', monospace" }}
        />
      </div>

      <PremiumToggle value={form.is_premium} onChange={() => set({ is_premium: !form.is_premium })} />
      <ErrorBanner message={error} />
      <div className="flex gap-3">
        <GradientButton type="submit" disabled={saving}>{saving ? 'Saving…' : 'Save Changes'}</GradientButton>
        <GhostButton type="button" onClick={() => { setEditing(false); setError(''); }}>Cancel</GhostButton>
      </div>
    </form>
  );
}
